import { useEffect } from 'react'
import { arrayMove } from '@dnd-kit/sortable'

interface useReorderProps {
  rows: Array<any>
  dragEndEvent: any | null
  setRows: Function
  sortRowsUrl: string
  reorderRows: Function
}

const useReorder = (props: useReorderProps) => {
  useEffect(() => {
    if (props.dragEndEvent === null) {
      return
    }

    const { active, over } = props.dragEndEvent

    if (active.id !== over.id) {
      const oldIndex = props.rows?.findIndex((row) => row.id === active.id)
      const newIndex = props.rows.findIndex((row) => row.id === over.id)

      const reOrdered = arrayMove(props.rows, oldIndex, newIndex)
      reOrdered.forEach((elm: any, i) => {
        elm.order = i++
      })
      const originalOrder = [...props.rows]
      props.setRows(reOrdered)
      props
        .reorderRows({
          sortRowsUrl: props.sortRowsUrl,
          data: reOrdered,
        })
        .then((result: boolean) => {
          if (!result) {
            originalOrder.forEach((elm: any, i) => {
              elm.order = i++
            })
            props.setRows(originalOrder)
          }
        })
    }
  }, [props.dragEndEvent])
}

export default useReorder
